import axios, { AxiosResponse, AxiosError } from 'axios';
// config
import { HOST_API } from '../config';

// ----------------------------------------------------------------------

const axiosInstance = axios.create({
  baseURL: HOST_API,
});

axiosInstance.interceptors.response.use(
  (response: AxiosResponse) => response,
  // (error: AxiosError) => Promise.reject((error.response && error.response.data) || 'Something went wrong')
  (error: AxiosError) => Promise.reject((error.response && error.response.data) || error.message)
);

export default axiosInstance;
